import { Box, Button, Grid, IconButton, styled, Typography } from '@mui/material';
import React from 'react';
import validIcon from '../../assets/img/valid_icon.svg';
import xIcon from '../../assets/img/close_icon.svg';

const NotificationTitle = styled(Typography)(({ theme }) => ({
  color: '#0017e7',
  fontWeight: 500,
  marginBottom: theme.spacing(3),
  fontSize: '40px',
  fontFamily: 'Poppins',
  [theme.breakpoints.down('sm')]: {
    fontSize: '32px',
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: '#0000004D',
  fontWeight: 500,
  marginBottom: theme.spacing(3),
  fontSize: '24px',
  fontFamily: 'Poppins',
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
  },
}));

const NotificationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(3),
  border: '1px solid #D9D9D9',
  borderRadius: 20,
  marginBottom:12,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
}));

const NotificationAvatar = styled(Box)(({ theme }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '6px',
  marginRight: theme.spacing(2),
  background: 'linear-gradient(to bottom right, #e9d5ff, #c084fc)',
  flexShrink: 0,
}));

const NotificationContent = styled(Box)(() => ({
  flexGrow: 1,
}));

const NotificationHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: '4px',
}));

const MarkAsReadButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#0017e7',
  color: 'white',
  textTransform: 'none',
  borderRadius: 10,
  height: 50,
  width: 170,
  '&:hover': {
    backgroundColor: '#0013b3',
  },
  padding: '10px 25px',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  [theme.breakpoints.down('sm')]: {
    width: 150,
    height: 45,
    padding: '8px 20px',
    gap: 8,
  },
}));

const DismissButton = styled(IconButton)(({ theme }) => ({
  width: 50,
  height: 50,
  borderRadius: '10px',
  padding: '10px',
  border: '1px solid #0017E7',
  marginLeft: 10,
  [theme.breakpoints.down('sm')]: {
    width: 40,
    height: 40,
    padding: '8px',
    marginLeft: 8,
  },
}));

const NotificationText = styled(Typography)(({ theme, read }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  opacity: read ? 0.75 : 1,
}));

const CompanyLogo = styled(Box)(({ theme }) => ({
  minWidth: '48px',
  minHeight: '48px',
  maxWidth: '48px',
  maxHeight: '48px',
  background: 'linear-gradient(135deg, rgba(0, 23, 231, 0.5) -54.69%, rgba(255, 204, 248, 0.5) 66.41%)',
  borderRadius: 14,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontSize: '0.75rem',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    minWidth: '40px',
    minHeight: '40px',
    maxWidth: '40px',
    maxHeight: '40px',
  },
}));
function NotificationCard({ isRead = false, notification, markNotificationsAsRead, onClick }) {
  return (
    <Box>
      <NotificationContainer>
        <Grid container spacing={2}>
          {/* Header Row */}
          <Grid item container xs={12} alignItems="center">
            <Grid item xs={8}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <CompanyLogo />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '100%',
                      color: '#000000',
                      paddingBottom: 1,
                    }}
                  >
                    Pulse.digital
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontWeight: 400,
                      fontSize: '8px',
                      lineHeight: '100%',
                      color: '#00000080',
                    }}
                  >
                    Today at 4:45
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* Action Buttons - Right-aligned */}
            <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Box sx={{ display: 'flex', gap: 0, alignItems: 'center' }}>
                {!isRead && (
                  <MarkAsReadButton onClick={() => markNotificationsAsRead(notification.id)}>
                    <img src={validIcon} alt="Mark as read" style={{ height: 12, width: 12 }} />
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '100%',
                      }}
                    >
                      Mark as read
                    </Typography>
                  </MarkAsReadButton>
                )}
                <DismissButton>
                  <img src={xIcon} alt="Dismiss" style={{ width: 16, height: 16 }} />
                </DismissButton>
              </Box>
            </Grid>
          </Grid>
          {/* Content Section */}
          <Grid item xs={12}>
            <NotificationContent>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: 1.5,
                  color: isRead? '#0000004D' : '#000000',
                }}
              >
                {notification.content}
              </Typography>
            </NotificationContent>
          </Grid>
        </Grid>
      </NotificationContainer>
    </Box>
  );
}

export default NotificationCard;